export default "__VITE_ASSET__Q1Z2_PR1__"